import {
  constructionAsset,
  constructionSafety,
  logisticsAsset,
  logisticsSafety,
  manufacturingAsset,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';

export default {
  desc: 'Vấn đề an toàn cho người lao động tại các cơ sở logistics là một trong những yếu tố rất quan trọng trong ngành logistics. Ngay cả trong quá trình thực hiện các công việc đa dạng như di chuyển, lưu trữ, xuất hàng hóa, luôn tiềm ẩn những nguy cơ tai nạn an toàn, và dù là tai nạn nhỏ cũng ngay lập tức gây ảnh hưởng xấu đến an toàn, năng suất và hiệu quả.',
  keywords:
    'An toàn cơ sở logistics, trung tâm logistics quy mô lớn, logistics quy mô lớn, người lao động logistics, quản lý an toàn lao động, an toan co so logistics, trung tam logistics quy mo lon, logistics quy mo lon, nguoi lao dong logistics, quan ly an toan lao dong.',
  ogSite: 'Cách quản lý an toàn cho người lao động tại cơ sở Smart Logistics',
  title: 'Cách quản lý an toàn cho người lao động tại cơ sở Smart Logistics',
  ogUrl: 'https://orbro.io/vi/blog/logisticsWorker',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AKsag4NdDe6oJsqBton9AjaPbL4Q5NxAVY66XFiGJrNW6Ib8-vKVwi61wEFWFuSoe0IzzjXlQbOtwFN55XZKQq8-merMyuu_Kc-aCU9rXsAxqlu4jJu1W48RqVrOHIVfqqqsE6lyVOnqs0-udnyCNaiR_P-55-JDEg1q7Xen3jEtC_J7Vb-agtwtcKFwspoLjunKXVBr9DX9XtbURNHamoE8axj_QTsyRGYEjihiSkLTZsKjMAFQ7XEjKC5gypKGi-6h70LVzMWxFYES1IEFrj_g1Xm7X_87ZICuq9UkXYfF5_kSsePap3XCgzaGjXTxtewamebrNTcvtyyOGiDJzCop_9ps9SiDxBVMH5GHlXgzqGmO97RWoXrAzVM73ecqHfZvofOY6_mcID1tD3eGIZBqVBgd7U8JQKxRv5VzLnj2nylAh5JYmN5uKSjOqTtNmcH5ryzlmyojOD2ErsaCkaHV5ExP87eOjZKQy4uKs_zWCdrgvAmWTPvzw69EDOlKv2RoG16hSWS_Ak_ejmhNKHqiapfSKTGHaC-OyuAl909u40AIfMQLdhaDAfq0dLJve-7i1wj3R4CLlyviq_bE_NXXUK5qw3DbmY5cmW6vI1h_bt2hkpZNfi3JDz5QhJ9DAcFdAWrfv2leATnS45LJW4WOW1oXUJDbzkHUZQHW0ZW6wIGYVQ-xlZWJJqhrD_Njlp8FUHTGIx0P4nbQ9gwzfH5XHMncEv6nMznbvF1pSn3RUd018qa27lJlV03sBikmB34XLF4CDCNEO1bQw9jWtbwk_vYV4M8X13pC0IyanCVU2du9J_GkiVXzFXfbzpyqQ9WOMjzjr1fz7PFZ9K4m9oA5JTQT4J3Zdqjx740QlfdBPLL-2yRp1LOhhELK6pOVdTjGXtjX3wv47zRDndoJU1_JRmZ4jZVB7-7HzJYviS1og154IRi0RIUkjfgjfUAA8LCVjWDHS32tJzSqsZXqKTXYRk9Rhi_YcjuhZLNetMYWCuiyoFBsqFmv6ai_Ux9jN66QNYaXnxRFnLddvNA6yApVZwoKPn-IzhYO8Vqv-0kVcG5eU-71tpilnn85vP3jJ6t79hkLY3n-fxyWgmRvnYI29nFIXJVmMfS6WNeeoqxKWJXUKMhbTVHH2pLy3fBnuVsWrrFjp1exyh-ahC1VHmDZbVVT2OhrELUuXeed4tfK3fgFsq066oX6o3XaihsVsvxd_7ohiRB6yCLuR0wSKZfvVqT9HQbGXWjOB6TZtXQpmsDzt_Hm4jCIyzgGJhQL-iMQZzqxalaYhQYVocsX1i6DSrWQD54jIik7h_PJfgK-eulk6EBtGZS3Tzf0Iaureqspuc_I8f4hcXRLWO2U5NnbnPZUmwxp-__Br0RSKSdBAv39o-tNXhLUk0-WF5nNiPAK4XlxF4hKVQl6nVCf5_wzw5t95Acv8QlXvmGuwe9etTZWlibVBH-aqe5_XOETlbldEKqJj_JN2mk1bGd6U2D5jYxlz5mexjaGdd6aWxF48u6hG_15sIUgXGqEHPhXvDJk6bTv_k7wgvoN1ESF_WKxkZuAnBZWa3G7jWW4VT6NK9Q3RxYq3VXTACR2nFRVJQ=w2052-h1199',
  ogType: 'website',
  date: '2023-09-06',
  tag1: '#Antoancosologistics',
  tag2: '#Trungtamlogisticsquymolon',
  tag3: '#Logisticsquymolon',
  tag4: '#Nguoilaodonglogistics',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Vấn đề an toàn cho người lao động tại các cơ sở logistics là một trong những yếu tố rất quan trọng trong ngành logistics. Ngay cả trong quá trình thực hiện các công việc đa dạng như di chuyển, lưu trữ, xuất hàng hóa, luôn tiềm ẩn những nguy cơ tai nạn an toàn, và dù là tai nạn nhỏ cũng ngay lập tức gây ảnh hưởng xấu đến an toàn, năng suất và hiệu quả. Tuy nhiên, nếu ứng dụng Hệ thống định vị thời gian thực (RTLS - Real-Time Location System), chúng ta có thể đảm bảo an toàn cho người lao động. Dưới đây, chúng ta sẽ tìm hiểu xem có thể quản lý an toàn cho người lao động và vận hành cơ sở logistics thông minh (Smart Logistics Facility) bằng những phương thức nào.',
      dot: '',
    },
    {
      head: 'Công nghệ RTLS là gì?',
      subHead: '',
      desc: 'Trước hết, RTLS (Hệ thống định vị thời gian thực) là công nghệ theo dõi thông tin vị trí theo thời gian thực, ứng dụng nhiều công nghệ đa dạng như GPS, RFID (Radio-Frequency Identification), UWB (Ultra-Wideband), BLE (Bluetooth Low Energy), v.v. Qua đó, có thể xác định chính xác vị trí của người lao động trong cơ sở logistics và sử dụng thông tin vị trí này để tạo dựng một môi trường làm việc an toàn.',
      dot: '',
    },
    {
      head: 'Các lợi ích chính',
      subHead: '1. Quản lý người lao động',
      desc: 'Công nghệ RTLS cho phép theo dõi vị trí của người lao động theo thời gian thực. Bằng cách xác định chính xác người lao động đang ở đâu trong cơ sở logistics, hệ thống giúp phòng ngừa va chạm giữa các công nhân hoặc va chạm với thiết bị nặng, đồng thời cho phép ứng phó nhanh chóng khi có tình huống khẩn cấp xảy ra. Điều này không chỉ đảm bảo an toàn mà còn có thể hỗ trợ rất lớn trong việc bố trí nhân lực hiệu quả và nâng cao hiệu suất tại hiện trường làm việc.',
      dot: '',
    },
    {
      head: '',
      subHead: '2. Thiết lập vùng an toàn, khu vực hạn chế',
      desc: 'Bên trong cơ sở logistics có thể có những khu vực nguy hiểm mà người lao động không được phép tiếp cận. Bằng cách sử dụng RTLS để thiết lập các vùng an toàn, hệ thống có thể ngay lập tức phát cảnh báo nguy hiểm nếu người ngoài hoặc người lao động không được phép tiếp cận khu vực đó. Ngược lại, cũng có thể thực hiện các biện pháp như phát cảnh báo nếu những người lao động cụ thể đi ra khỏi khu vực được phép. Qua đó, có thể phòng ngừa tai nạn từ trước.',
      dot: '',
    },
    {
      head: '',
      subHead: '3. Ứng phó tình huống khẩn cấp',
      desc: 'Khi người lao động gặp tình huống khẩn cấp, công nghệ RTLS cho phép nhanh chóng xác định thông tin vị trí của họ. Nhờ đó, có thể tiến hành ứng cứu hoặc sơ cứu kịp thời, đảm bảo an toàn cho người lao động.',
      dot: '',
    },
    {
      head: '',
      subHead: '4. Hiệu quả và năng suất',
      desc: 'Việc nắm bắt lộ trình di chuyển của người lao động thông qua RTLS giúp tối ưu hóa quy trình làm việc. Nếu không chỉ theo dõi lộ trình của người lao động mà còn kết hợp với giải pháp theo dõi tài sản (asset tracking solution), thì có thể vận hành một cơ sở logistics cực kỳ tiên tiến.',
      dot: '',
    },
    {
      head: 'Kết luận',
      subHead: '',
      desc: 'An toàn của người lao động tại cơ sở logistics có tầm quan trọng lớn trong ngành logistics, và việc ứng dụng công nghệ RTLS để quản lý và cải thiện vấn đề này là rất hiệu quả. Bằng cách theo dõi vị trí của người lao động theo thời gian thực và tạo dựng môi trường làm việc an toàn, có thể nâng cao sự an toàn cho người lao động và góp phần phòng ngừa tai nạn. Việc ứng dụng công nghệ RTLS sẽ mở ra một tương lai tốt đẹp hơn cho hoạt động vận hành cơ sở logistics.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/vi/enterprise/logistics/safety',
      },
      {
        img: manufacturingAsset.thumb,
        data: 'manufacturingAsset',
        link: '/vi/enterprise/manufacturing/asset',
      },
    ],
  },
};
